module.exports = __webpack_public_path__ + "img/icon1@2x.420e9872.png";